import { REMOVE_COURSE_FROM_STUDENT } from "../actions/user_actions";

const studentReducer = (state = {}, action) => {
  switch (action.type) {
    case REMOVE_COURSE_FROM_STUDENT:
      return {
        ...state,
        ...action.updatedStudent,
      };
    default:
      return state;
  }
};

export default studentReducer;
